/**
 * @file PresetPlacePicker.tsx
 * @description «Куда: после «…» · изменить» в библиотеке заготовок
 * (phase19.16 Р2; uiux-design-r2 §5): место вставки нового блока — в начало,
 * после любого блока страницы или в конец.
 */

import { JUMP_LINK_CLASS } from "../../ui/jump-link";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { numberedTitles, placeLabel } from "../../../lib/site-builder/preset-library";

export interface PlaceBlock {
  id: string;
  title: string;
}

interface Props {
  after: string | null | undefined;
  blocks: readonly PlaceBlock[];
  onChange: (after: string | null | undefined) => void;
  /** Имя места блога («над лентой блога») вместо «страницы». */
  placeName?: string;
}

export function PresetPlacePicker({ after, blocks, onChange, placeName }: Props) {
  const named = numberedTitles(blocks);
  const label = placeLabel(after, (id) => named.find((b) => b.id === id) ?? null, placeName);
  return (
    <p className="type-caption flex min-w-0 flex-wrap items-center gap-x-2 text-on-surface-variant">
      <span className="min-w-0 truncate">Куда: {label}</span>
      {blocks.length > 0 ? (
        <DropdownMenu>
          <DropdownMenuTrigger
            render={(props) => (
              <button {...props} type="button" className={JUMP_LINK_CLASS}>
                изменить
              </button>
            )}
          />
          <DropdownMenuContent align="start" className="max-h-[60dvh] w-72 max-w-[calc(100vw-2rem)] overflow-y-auto">
            <DropdownMenuItem onClick={() => onChange(null)} className="min-h-12">
              {placeName ? "Первым" : "В начало страницы"}
            </DropdownMenuItem>
            {named.map((b) => (
              <DropdownMenuItem key={b.id} onClick={() => onChange(b.id)} className="min-h-12">
                <span className="truncate">
                  После «{b.title}»{b.suffix}
                </span>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : null}
    </p>
  );
}
